/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FiChild,
  FiParent,
  FiServices,
  FscdIntakeApplication,
  ModifiedYesNoOptionsUnsureYes,
  ServiceDurationOptions,
} from '@fscd-intake/entities';
import { DatePipe, formatDate } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as constants from '@common/constants';
import { Address, Document, PhoneNumber } from '@common/entities';
import { FileService, LabelTextPipe } from '@common/ui/shared-components';
import { Utilities } from '@common/utils';
import { camelCase, startCase } from 'lodash';
import * as pdfMake from 'pdfmake/build/pdfmake.min';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Column, TDocumentDefinitions } from 'pdfmake/interfaces';
import { StyleDictionary } from 'pdfmake/interfaces';
import { filter, map } from 'rxjs/operators';
import * as dayjs from 'dayjs';
import { FiChildInfoLabels, FiParentInfoLabels, FiServicesLabels } from '@common/labels';
import { MINISTRY_NAME_LONG } from '@common/constants';

// changed to pdfmake.min to pull in minified bundle to shrink bundle size
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfGenerationService {
  childInfolabels = FiChildInfoLabels;
  parentInfolabels = FiParentInfoLabels;
  servicesLabels = FiServicesLabels;
  labelTextPipe = new LabelTextPipe();
  utility = Utilities;
  private _columnWidth = '*';
  private albertaLogo = `<svg xmlns="http://www.w3.org/2000/svg" width="149" height="42" viewBox="0 0 216 61" shape-rendering="geometricPrecision">
                            <rect class="logo" fill="#00aad2" x="196.411" y="31.014" width="19.59" height="19.592"></rect>
                            <path class="logo" fill="#5f6a72" d="M91.271,47.934c-1.972,0.198-4.068,0.382-6.278,0.548c0.833-6.288,4.105-15.027,8.177-13.62C95.521,35.676,94.284,43.033,91.271,47.934 M86.106,52.264c-0.714,0.111-1.304,0.101-1.773,0.014c0.28-0.241,0.455-0.594,0.455-1.014c0-0.266,0.009-0.544,0.024-0.832c1.104-0.052,2.831-0.177,4.888-0.376C88.623,51.241,87.409,52.067,86.106,52.264 M111.223,37.314c2.598-2.413,3.89-2.237,4.231-1.589c0.736,1.403-2.325,6.345-8.184,9.047C107.774,42.114,109.176,39.216,111.223,37.314 M207.625,39.712c-0.251-4.887-4.579-5.683-5.176-4.293c-0.208,0.487,1.626,0.313,1.633,3.764c0.005,5.71-5.787,13.165-13.167,13.165c-8.04,0-10.114-6.254-10.502-9.348c-0.256-2.058,0.187-5.029-3.368-4.636c-2.486,0.28-4.733,5.12-7.885,9.196c-2.704,3.499-3.918,3.166-3.286,0.163c0.783-3.763,3.925-12.594,7.517-13.237c1.661-0.297,2.257,2.625,3.02,0.796c0.768-1.832,0.063-5.783-3.655-5.783c-2.605,0-5.73,2.762-8.292,5.905c-2.233,2.744-13.522,19.357-18.257,15.77c-2.215-1.676-2.035-8.506-0.643-16.553c5.618-2.167,10.292-1.456,12.936-0.188c1.305,0.626,1.485,0.532,0.929-0.903c-0.825-2.108-5.345-5.405-12.405-3.888c-0.17,0.033-0.336,0.079-0.505,0.119c0.569-2.613,1.231-5.268,1.954-7.849c0.661-2.364,2.6-6.454-2.462-7.242c-1.613-0.252-0.927,0.53-1.459,2.71c-0.978,4.015-2.214,9.227-3.109,14.458c-4.161,2.396-8.035,6.399-10.874,11.667c0.492-2.429,1.254-5.116,1.308-6.93c0.054-1.911-1.255-2.332-1.763-2.482c-1.111-0.314-2.453,0.236-3.776,2.106c-3.104,4.37-7.035,11.284-13.001,14.184c-4.28,2.081-6.157-0.015-6.262-3.238c0.845-0.259,1.601-0.525,2.24-0.813c7.756-3.437,10.419-8.621,8.448-11.774c-1.87-3-7.217-2.086-11.439,2.361c-2.081,2.193-3.684,5.956-3.871,9.387c-1.79,0.387-3.848,0.731-6.146,1.041c3.644-5.911,3.329-13.9-2.001-15.247c-6.182-1.561-9.309,4.44-10.633,9.436c0.408-4.996,1.206-11.077,2.335-16.725c0.472-2.361,2.087-6.455-3.041-7.24c-1.629-0.252-1.377,0.505-1.241,2.71c0.18,2.958-3.096,20.875-1.384,28.744c-2.206,0.714-3.101,2.375-0.264,4.127c1.955,1.203,6.258,1.603,10.605-0.537c1.559-0.771,2.909-1.854,4.034-3.125c2.59-0.326,5.314-0.744,7.796-1.241c0.425,3.45,2.677,6.095,7.905,5.606c7.433-0.691,14.035-9.826,16.528-14.226c-0.45,4.716-3.519,15.019,1.716,14.49c2.051-0.208,1.158-0.536,1.285-2.306c0.454-6.208,5.62-11.47,10.73-14.694c-0.887,7.602-0.579,14.391,2.868,16.546c6.341,3.963,15.326-6.477,20.27-12.862c-2.516,5.671-3.945,12.936-0.164,14.047c4.435,1.293,7.932-6.063,12.022-11.693c0.475,4.042,3.168,11.003,14.033,11.003C200.729,54.163,208.007,47.148,207.625,39.712 M51.101,52.114c-2.665-0.965-6.464-2.513-11.424-5.046c2.717-0.991,6.169-2.443,9.806-4.345C49.973,46.873,50.505,49.892,51.101,52.114M80.545,57.718c-0.125-0.258-0.849,0.105-1.587-0.003c-2.101-0.31-4.863-3.18-5.699-7.896c-1.504-8.489-0.612-16.865,1.88-29.348c0.47-2.361,2.084-6.451-3.041-7.243c-1.63-0.251-0.786,0.554-1.243,2.71c-1.971,9.297-9.574,15.999-17.207,20.493c-0.799-10.645-0.474-22.465,1.53-29.714c1.691-6.115,3.703-4.992,1.209-6.277c-2.624-1.352-5.445,0.435-7.726,4.989c-2.28,4.552-12.795,29.289-29.584,45.984c-8.592,8.545-16.363,4.146-17.919,2.831c-1.266-1.069-1.734,0.582-0.163,2.271c6.949,7.494,17.1,3.194,20.795-0.5c10.215-10.21,22.092-32.19,26.897-41.517c-0.443,5.251-0.593,14.058,0.385,24.379c-5.199,2.533-9.86,4.021-12.059,4.601c-2.381,0.624-3.854,1.593-3.898,2.697c-0.047,1.208,1.552,2.227,3.863,3.325c4.116,1.954,16.167,7.647,19.136,9.374c2.543,1.476,3.784,0.325,4.537-1.268c0.983-2.076-1.716-3.276-4.328-4.057c-1.006-3.495-1.81-8.196-2.345-13.377c6.126-3.772,12.158-8.793,15.635-15.068c-0.876,5.245-3.124,23.08,2.507,30.621c1.241,1.662,3.981,3.479,6.656,3.209C80.036,58.805,80.671,57.977,80.545,57.718"></path>
                        </svg>`;

  constructor(private fileService: FileService, private datePipe: DatePipe) {}

  private readonly styleDictionary: StyleDictionary = {
    defaultStyle: {
      fontSize: 12,
      lineHeight: 1.5,
    },
    h1: {
      bold: true,
      fontSize: 16,
      margin: [0, 20, 0, 20],
    },
    h2: {
      bold: true,
      fontSize: 15,
      margin: [0, 20, 0, 10],
    },
    firstH2: {
      bold: true,
      fontSize: 15,
      margin: [0, 0, 0, 10],
    },
    subHeader: {
      margin: [0, 10, 0, 10],
      fontSize: 14,
      alignment: 'center',
      bold: true,
    },
    marginTopBottom: {
      margin: [0, 10, 0, 10],
    },
    marginBottom: {
      margin: [0, 0, 0, 10],
    },
    marginLeftBottom: {
      margin: [25, 0, 0, 10],
    },
    marginFurtherLeft: {
      margin: [40, 0, 0, 10],
    },
    tableRow: {
      margin: [0, 5, 0, 5],
    },
    horizontal10: {
      margin: [10, 0, 0, 10],
    },
    marginTop: {
      margin: [0, 25, 0, 0],
    },
    marginExtraBottom: {
      margin: [0, 0, 0, 20],
    },
    marginExtraLeftBottom: {
      margin: [25, 0, 0, 20],
    },
    footerLeft: {
      fontSize: 9,
      margin: [40, 0, 0, 0],
      color: '#707070',
    },
    footerRight: {
      fontSize: 9,
      margin: [0, 0, 40, 0],
      color: '#707070',
      alignment: 'right',
    },
  };

  private readonly documentPermissions = {
    printing: 'highResolution',
    modifying: false,
    copying: true,
    annotating: true,
    fillingForms: false,
  };

  public generatePdf(application: FscdIntakeApplication): TDocumentDefinitions {
    const documentDefinition = {
      content: [
        this.coverPageContent(application.applicationNumber, application.child, application.parent, new Date()),
        this.childInfoContent(application.child),
        this.parentInfoContent(application.parent),
        this.servicesPageContent(application.services),
        this.documentsSummary(application),
      ],
      styles: this.styleDictionary,
      pageSize: 'LETTER',
      pageMargins: [40, 50, 40, 50],
      info: { title: 'FSCD Application' },
      permissions: this.documentPermissions,
      footer: this.getFooter(),
    } as TDocumentDefinitions;

    return documentDefinition;
  }

  public async uploadPdf(application: FscdIntakeApplication): Promise<any> {
    // generate document definition
    const docDef = this.generatePdf(application);

    // create pdf object
    const data = pdfMake.createPdf(docDef);

    // we need to wrap the getBlob in a new Promise function because it returns void and thus there is nothing to await and will not block and further execution
    const wait = (pdfData) =>
      new Promise<any>((resolve) => {
        pdfData.getBlob(
          (blob) => {
            const file = new File([blob], 'something.pdf');

            const fileProperties = this.fileService
              .upload(application.id, file)
              .pipe(filter((res) => res.type === HttpEventType.Response))
              .pipe(
                map((res: any) => {
                  const response = {
                    key: res.key,
                    azureUrl: res.azureUrl,
                  };
                  return response;
                })
              )
              .toPromise();

            resolve(fileProperties);
          },
          (reject) => {
            reject();
          }
        );
      });

    const output = await wait(data);

    return output;
  }

  public generateQuestionAnswerColumnPair(label: string, value: any, dateFormat?: string): Column[] {
    const question = [
      { text: label, width: this._columnWidth },
      { text: this.convertValueToString(value, dateFormat), bold: true },
    ] as Column[];

    return question;
  }

  public convertValueToString(value: any, dateFormat?: string): string {
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    } else if (value === null || value === undefined || value === '') {
      return '-';
    } else if (typeof value === 'number') {
      return value.toString();
    } else {
      if (Object.getPrototypeOf(value)['constructor'].name === 'Date') {
        const format = dateFormat ?? 'longDate';
        const dateString = this.datePipe.transform(value, format, '+0000');
        return dateString;
      }

      return value;
    }
  }

  public getFooter() {
    const now = formatDate(Utilities.edmontonTime(undefined, undefined), 'longDate', 'en-CA');
    return function (currentPage, pageCount) {
      return [
        {
          table: {
            headerRows: 1,
            widths: ['75%', '25%'],
            body: [
              [
                {
                  text: currentPage === 3 ? `' - ' : User didn't enter the information` : '',
                  style: 'footerLeft',
                  italics: true,
                },
                { text: '' },
              ],
              [
                {
                  text: `Generated by FSCD Support | ${now} | ${MINISTRY_NAME_LONG}`,
                  style: 'footerLeft',
                },
                { text: `Page ${currentPage} of ${pageCount}`, style: 'footerRight' },
              ],
            ],
          },
          layout: 'noBorders',
        },
      ];
    };
  }

  private documentsSummary(application: FscdIntakeApplication) {
    const docSummaryObj = [];

    docSummaryObj.push(this.sectionHeader('Submitted documents'));
    docSummaryObj.push(this.documentsSummaryTable(this.applicantDocuments(application)));
    return docSummaryObj;
  }

  private documentsSummaryTable(documentCollection) {
    let documentTable = {};
    if (documentCollection) {
      documentTable = {
        layout: 'lightHorizontalLines',
        table: {
          headerRows: 1,
          heights: 15,
          widths: ['30%', '25%', '*'],
          body: this.buildDocumentSummaryTableBody(documentCollection),
        },
        margin: [0, 5, 10, 5],
      };
    }
    return documentTable;
  }

  private buildDocumentSummaryTableBody(documentCollection) {
    const body = [];
    const columns = [];
    columns.push({ text: 'Section', bold: true });
    columns.push({ text: 'Document type', bold: true });
    columns.push({ text: 'File name', bold: true });
    body.push(columns);

    documentCollection.forEach((element) => {
      let row = [];
      const docs = element.value as Document[];
      row.push({
        text: element.key,
        style: 'tableRow',
        rowSpan: docs.length,
      });
      docs.forEach((doc, index) => {
        if (index > 0) {
          row = [];
          row.push({});
        }
        row.push({ text: doc.documentType || startCase(camelCase(doc.documentCategory)), style: 'tableRow' });
        row.push({ text: doc.name, style: 'tableRow' });
        body.push(row);
      });
    });
    return body;
  }

  public applicantDocuments(application: FscdIntakeApplication) {
    const applicantDocuments = [];
    let childDocuments: Document[] = [];

    if (application.child?.identityDocuments?.length > 0)
      childDocuments = [...childDocuments, ...application.child.identityDocuments];

    if (application.child?.medicalDocuments?.length > 0)
      childDocuments = [...childDocuments, ...application.child.medicalDocuments];

    if (application.child?.additionalDocuments?.length > 0)
      childDocuments = [...childDocuments, ...application.child.additionalDocuments];

    if (childDocuments.length > 0) applicantDocuments.push({ key: 'Child information', value: childDocuments });

    if (application.parent?.documents?.length > 0)
      applicantDocuments.push({ key: 'Parent/Guadian Infomation', value: application.parent.documents });

    return applicantDocuments;
  }

  private childInfoContent(child: FiChild) {
    const result = [
      this.sectionHeader(this.labelTextPipe.transform(this.childInfolabels.header)),
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.firstName),
          child?.firstName
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.middleName),
          child?.middleName
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.lastName),
          child?.lastName
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.preferredName),
          child?.preferredName
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.birthdate),
          child?.birthdate
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.gender),
          constants.Genders[child?.gender]?.displayValue
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.hasPrevApplication),
          child?.hasPrevApplication ? 'Yes' : 'No'
        ),
        style: 'marginBottom',
      },
    ];

    if (child?.hasPrevApplication) {
      result.push({
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.hasPrevClosedWithin90),
          ModifiedYesNoOptionsUnsureYes[child?.hasPrevClosedWithin90]?.displayValue
        ),
        style: 'marginBottom',
      });
    }

    result.push(
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.isChildCitizenOrPermanentResident),
          constants.FiLegalStatus[child?.citizenImmigrationStatus]?.displayValue ?? '-'
        ),
        style: 'marginBottom',
      },
      ...this.addressContent(child?.residentialAddress),
      ...this.mailingAddressContent(child),
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.livingArrangements),
          child?.livingArrangements
        ),
        style: 'marginTopBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.hasConfirmedDiagnosis),
          child?.hasConfirmedDiagnosis ? `Yes \n ${child?.confirmedDiagnosis}` : 'No'
        ),
        style: 'marginTopBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.childInfolabels.isAwaitingDiagnosis),
          child?.isAwaitingDiagnosis ? `Yes \n ${child?.waitingDiagnosis}` : 'No'
        ),
        style: 'marginTopBottom',
      }
    );

    return result;
  }

  private parentInfoContent(parent: FiParent) {
    const result = [
      this.sectionHeader(this.labelTextPipe.transform(this.parentInfolabels.header)),
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.firstName),
          parent?.firstName
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.middleName),
          parent?.middleName
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.lastName),
          parent?.lastName
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.preferredName),
          parent?.preferredName
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.birthdate),
          parent?.birthdate
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.gender),
          constants.Genders[parent?.gender]?.displayValue
        ),
        style: 'marginExtraBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.isEnglishFirstLanguage),
          parent?.isEnglishFirstLanguage
        ),
        style: 'marginExtraBottom',
      },
    ];

    if (!parent?.isEnglishFirstLanguage) {
      result.push(
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.primaryLanguage),
            parent?.primaryLanguage
          ),
          style: 'marginLeftBottom',
        },
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.requiresInterpreter),
            parent?.requiresInterpreter
          ),
          style: 'marginExtraLeftBottom',
        }
      );
    }

    result.push({
      columns: this.generateQuestionAnswerColumnPair(
        this.labelTextPipe.transform(this.parentInfolabels.haveOtherCommunicationNeed),
        parent?.haveOtherCommunicationNeed
      ),
      style: 'marginExtraBottom',
    });

    if (parent?.haveOtherCommunicationNeed) {
      result.push({
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.otherCommunicationNeed),
          parent?.otherCommunicationNeed
        ),
        style: 'marginExtraLeftBottom',
      });
    }

    result.push(
      this.phoneNumberContent(
        parent?.phoneNumbers,
        this.labelTextPipe.transform(this.parentInfolabels.phoneNumber),
        false,
        true
      ),
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.email),
          parent?.email
        ),
        style: 'marginExtraBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.hasSameAddressAsChild),
          parent?.hasSameAddressAsChild
        ),
        style: 'marginBottom',
      }
    );

    if (!parent?.hasSameAddressAsChild && parent?.residentialAddress) {
      result.push(...this.addressContent(parent?.residentialAddress, true));
    }

    result.push({
      columns: this.generateQuestionAnswerColumnPair(
        this.labelTextPipe.transform(this.parentInfolabels.relationToChild),
        constants.FiRelations[parent?.relationToChild]?.displayValue ?? '-'
      ),
      style: 'marginTopBottom',
    });
    result.push({
      columns: this.generateQuestionAnswerColumnPair(
        this.labelTextPipe.transform(this.parentInfolabels.learnAboutFscd),
        this.getLearnAboutFscdValues(parent) ?? '-'
      ),
      style: 'marginTopBottom',
    });

    if (parent?.learnAboutFscdOther) {
      result.push({
        columns: this.generateQuestionAnswerColumnPair('', 'Other: ' + parent?.learnAboutFscdOtherDetail),
        style: 'marginBottom',
      });
    }

    if (parent?.hasSecondParent) {
      const secondParentContents = [
        this.sectionHeader(this.labelTextPipe.transform(this.parentInfolabels.secondParentheader)),
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.firstName),
            parent?.secondParent?.firstName
          ),
          style: 'marginBottom',
        },
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.middleName),
            parent?.secondParent?.middleName
          ),
          style: 'marginBottom',
        },
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.lastName),
            parent?.secondParent?.lastName
          ),
          style: 'marginBottom',
        },
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.preferredName),
            parent?.secondParent?.preferredName
          ),
          style: 'marginBottom',
        },
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.birthdate),
            parent?.secondParent?.birthdate
          ),
          style: 'marginBottom',
        },
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.gender),
            constants.Genders[parent?.secondParent?.gender]?.displayValue
          ),
          style: 'marginExtraBottom',
        },
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.isEnglishFirstLanguage),
            parent?.secondParent?.isEnglishFirstLanguage
          ),
          style: 'marginExtraBottom',
        },
      ];

      if (!parent?.secondParent?.isEnglishFirstLanguage) {
        secondParentContents.push(
          {
            columns: this.generateQuestionAnswerColumnPair(
              this.labelTextPipe.transform(this.parentInfolabels.primaryLanguage),
              parent?.secondParent?.primaryLanguage
            ),
            style: 'marginLeftBottom',
          },
          {
            columns: this.generateQuestionAnswerColumnPair(
              this.labelTextPipe.transform(this.parentInfolabels.requiresInterpreter),
              parent?.secondParent?.requiresInterpreter
            ),
            style: 'marginExtraLeftBottom',
          }
        );
      }

      secondParentContents.push({
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.haveOtherCommunicationNeed),
          parent?.secondParent?.haveOtherCommunicationNeed
        ),
        style: 'marginExtraBottom',
      });

      if (parent?.secondParent?.haveOtherCommunicationNeed) {
        secondParentContents.push({
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.otherCommunicationNeed),
            parent?.secondParent?.otherCommunicationNeed
          ),
          style: 'marginExtraLeftBottom',
        });
      }

      secondParentContents.push(
        this.phoneNumberContent(
          parent?.secondParent?.phoneNumbers,
          this.labelTextPipe.transform(this.parentInfolabels.phoneNumber),
          false,
          true
        ),
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.email),
            parent?.secondParent?.email
          ),
          style: 'marginBottom',
        },
        {
          columns: this.generateQuestionAnswerColumnPair(
            this.labelTextPipe.transform(this.parentInfolabels.hasSameAddressAsChild),
            parent?.secondParent?.hasSameAddressAsChild
          ),
          style: 'marginTopBottom',
        }
      );

      if (!parent?.secondParent?.hasSameAddressAsChild && parent?.secondParent?.residentialAddress) {
        secondParentContents.push(...this.addressContent(parent?.secondParent?.residentialAddress, true));
      }

      secondParentContents.push({
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.parentInfolabels.relationToChild),
          constants.FiRelations[parent?.secondParent?.relationToChild]?.displayValue ?? '-'
        ),
        style: 'marginTopBottom',
      });
      result.push(...secondParentContents);
    }

    return result;
  }

  servicesPageContent(services: FiServices) {
    const servicesObj = [
      this.sectionHeader(this.labelTextPipe.transform(this.servicesLabels.header)),
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.servicesLabels.homeRespite),
          ModifiedYesNoOptionsUnsureYes[services?.homeRespite]?.displayValue
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.servicesLabels.medicalAppointment),
          ModifiedYesNoOptionsUnsureYes[services?.medicalAppointment]?.displayValue
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.servicesLabels.counselling),
          ModifiedYesNoOptionsUnsureYes[services?.counselling]?.displayValue
        ),
        style: 'marginBottom',
      },
      {
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.servicesLabels.clothingFootwear),
          ModifiedYesNoOptionsUnsureYes[services?.clothingFootwear]?.displayValue
        ),
        style: 'marginBottom',
      },
    ];
    if (services?.agreementDuration) {
      servicesObj.push({
        columns: this.generateQuestionAnswerColumnPair(
          this.labelTextPipe.transform(this.servicesLabels.agreementDuration),
          ServiceDurationOptions[services?.agreementDuration]?.displayValue
        ),
        style: 'marginBottom',
      });
    }
    return servicesObj;
  }

  private addressContent(address: Address, indented: boolean = false) {
    const addressObj = [];

    addressObj.push({
      columns: this.generateQuestionAnswerColumnPair(
        this.labelTextPipe.transform(this.childInfolabels.street),
        address?.streetAddress
      ),
      style: 'marginBottom',
      margin: indented ? [20, 10, 0, 10] : [0, 10, 0, 10],
    });
    addressObj.push({
      columns: this.generateQuestionAnswerColumnPair(
        this.labelTextPipe.transform(this.childInfolabels.suite),
        address?.suiteNumber
      ),
      style: 'marginBottom',
      margin: indented ? [20, 0, 0, 10] : [0, 0, 0, 10],
    });
    addressObj.push({
      columns: this.generateQuestionAnswerColumnPair(
        this.labelTextPipe.transform(this.childInfolabels.city),
        address?.city
      ),
      style: 'marginBottom',
      margin: indented ? [20, 0, 0, 10] : [0, 0, 0, 10],
    });
    addressObj.push({
      columns: this.generateQuestionAnswerColumnPair(
        this.labelTextPipe.transform(this.childInfolabels.province),
        address?.province
      ),
      style: 'marginBottom',
      margin: indented ? [20, 0, 0, 10] : [0, 0, 0, 10],
    });
    addressObj.push({
      columns: this.generateQuestionAnswerColumnPair(
        this.labelTextPipe.transform(this.childInfolabels.postalCode),
        address?.postalCode
          ? `${address?.postalCode.slice(0, 3).toUpperCase()} ${address?.postalCode.slice(3).toUpperCase()}`
          : '-'
      ),
      style: 'marginBottom',
      margin: indented ? [20, 0, 0, 10] : [0, 0, 0, 10],
    });

    return addressObj;
  }

  private mailingAddressContent(child: FiChild) {
    const mailingAddressObj = [];

    mailingAddressObj.push({
      columns: this.generateQuestionAnswerColumnPair(
        this.labelTextPipe.transform(this.childInfolabels.hasSameMailingAddress),
        child?.hasSameMailingAddress
      ),
      style: 'marginBottom',
      margin: [0, 10, 0, 10],
    });

    if (!child?.hasSameMailingAddress && child?.mailingAddress) {
      mailingAddressObj.push(this.addressContent(child.mailingAddress, true));
    }

    return mailingAddressObj;
  }
  //TODO: remove this method once 'hasDifferentMailingAddress' is fixed on parent page
  // private parentMailingAddressContent(parent: FiParent) {
  //   const mailingAddressObj = [];

  //   mailingAddressObj.push({
  //     columns: this.generateQuestionAnswerColumnPair(
  //       'Is your residential address the same as the child?',
  //       parent?.hasSameAddressAsChild
  //     ),
  //     style: 'marginBottom',
  //     margin: [0, 10, 0, 10],
  //   });

  //   if (!parent?.hasSameAddressAsChild && parent?.mailingAddress) {
  //     mailingAddressObj.push(this.addressContent(parent.mailingAddress, true));
  //   }

  //   return mailingAddressObj;
  // }

  private coverPageContent(applicatonNumber: string, child: FiChild, parent: FiParent, submittedOn: Date) {
    const coverPageObj = [];
    coverPageObj.push(this.pageHeader());

    coverPageObj.push(
      {
        text: 'FSCD Application Submission Confirmation',
        style: 'h2',
        margin: [0, 90, 0, 10],
        alignment: 'center',
      },
      {
        text: `Applicant name: ${child.firstName.trim()} ${child.lastName.trim()}`,
        style: 'h2',
        margin: [0, 10, 0, 10],
        alignment: 'center',
      },
      {
        text: `Application number:  ${applicatonNumber || 'XXXXXX'}`,
        style: 'h2',
        margin: [0, 10, 0, 10],
        alignment: 'center',
      },
      {
        text: `The FSCD (Family Supports for Children with Disabilities) application for ${child.firstName.trim()} ${child.lastName.trim()} has been successfully submitted on ${dayjs(
          submittedOn
        ).format('MMM D, YYYY')}, ${dayjs(submittedOn).format('HH:mm')}.`,
        style: 'marginBottom',
        margin: [0, 70, 0, 10],
        alignment: 'left',
      },
      {
        text: 'When we get your completed package, including all supporting documents, we will review it to see if your child is eligible for FSCD.',
        style: 'marginBottom',
        alignment: 'left',
        margin: [0, 12, 0, 10],
      },
      {
        text: 'We will contact you regarding your eligibility, or if more information or documents are required.',
        style: 'marginBottom',
        alignment: 'left',
        margin: [0, 12, 0, 10],
      },
      {
        text: 'If you have any questions about your FSCD Application, please call the Alberta Supports Contact Centre toll free at 1-877-644-9992 or 780-644-9992 in Edmonton.',
        style: 'marginBottom',
        alignment: 'left',
        margin: [0, 12, 0, 10],
      },
      {
        text: 'Sincerely,',
        style: 'marginBottom',
        alignment: 'left',
        margin: [0, 30, 0, 10],
      },
      {
        text: 'FSCD Application Unit',
        style: 'marginBottom',
        alignment: 'left',
        margin: [0, 0, 0, 10],
        pageBreak: 'after',
      }
    );

    return coverPageObj;
  }

  private phoneNumberContent(
    phoneNumbers: PhoneNumber[],
    label: string,
    leftIndent = false,
    singleLineItemFormat = false
  ) {
    const phObj = [];
    const hasPhoneNumber = phoneNumbers && phoneNumbers.length > 0 && phoneNumbers[0]?.phoneNumber?.length > 0;
    if (!hasPhoneNumber) {
      phObj.push({
        columns: this.generateQuestionAnswerColumnPair(label, null),
        style: leftIndent ? 'marginLeftBottom' : 'marginBottom',
      });
      return phObj;
    }

    if (!singleLineItemFormat) {
      phObj.push({ text: label, style: leftIndent ? 'marginLeftBottom' : 'marginBottom' });
    }
    if (phoneNumbers) {
      phoneNumbers.forEach((phone) => {
        if (phone.phoneNumber && phone.phoneNumber.length > 0) {
          let phoneSubLabel = phone.type;
          if (singleLineItemFormat) {
            phoneSubLabel = `${label} (${phone.type})`;
            phObj.push({
              columns: this.generateQuestionAnswerColumnPair(phoneSubLabel, this.formatPhoneFax(phone.phoneNumber)),
              style: leftIndent ? 'marginLeftBottom' : 'marginBottom',
            });
          } else {
            phObj.push({
              columns: this.generateQuestionAnswerColumnPair(phoneSubLabel, this.formatPhoneFax(phone.phoneNumber)),
              style: leftIndent ? 'marginFurtherLeft' : 'marginLeftBottom',
            });
          }
        }
      });
    }
    return phObj;
  }

  private formatPhoneFax(phoneFaxValue: string) {
    if (!phoneFaxValue) return null;

    let formatPhoneFax = phoneFaxValue.trim();
    if (formatPhoneFax.length === 10) {
      formatPhoneFax = `${phoneFaxValue.slice(0, 3)} ${phoneFaxValue.slice(3, 6)} ${phoneFaxValue.slice(6)}`;
    }
    return formatPhoneFax;
  }

  private pageHeader() {
    let pageHeader = {};

    pageHeader = {
      columns: [
        {
          width: '*',
          alignment: 'left',
          stack: [
            {
              text: '',
              style: 'h1',
            },
          ],
        },
        {
          width: 'auto',
          stack: [
            {
              svg: this.albertaLogo,
            },
          ],
        },
      ],
    };
    return pageHeader;
  }

  private sectionHeader(text: string) {
    let headerRow = {};
    headerRow = {
      table: {
        widths: ['*'],
        body: [
          [
            {
              text: text,
              fillColor: '#0081A2',
              color: '#FFFFFF',
            },
          ],
        ],
      },
      layout: 'noBorders',
      style: 'subHeader',
    };
    return headerRow;
  }

  getLearnAboutFscdValues(parent: FiParent): string {
    if (!parent) return null;

    const values = [];
    if (parent.learnAboutFscdPhysician) values.push('Physician');
    if (parent.learnAboutFscdHospital) values.push('Hospital');
    if (parent.learnAboutFscdAgency) values.push('Agency');
    if (parent.learnAboutFscdEarlyInterventionProgram) values.push('Early Intervention Program');
    if (parent.learnAboutFscdEasterSeals) values.push('Easter Seals');
    if (parent.learnAboutFscdHealthUnit) values.push('Health Unit');
    if (parent.learnAboutFscdSchool) values.push('School');
    if (parent.learnAboutFscdChildrensServices) values.push("Children's Services");

    if (values.length === 0) return null;

    return values.join(', ');
  }
}
